import React from 'react';

import {blogData} from "../data/blog/blogData";
import {Link, useParams} from "react-router-dom";

import './styles/BlogItem.scss'

import dayjs from 'dayjs'
import 'dayjs/locale/ru' // Подключение локализации

function BlogItem(props) {
    const {blogItemId} = useParams()

    let blogItemData = blogData.find((item) => {
        return item.id === Number(blogItemId)
    })

    const date = dayjs(blogItemData.createdAt).locale('ru').format('D MMMM YYYY');

    return (
        <div className={'blog-item-container'}>

            <Link to="../blog" className="blog-item-container__back-button tp-underline">
                Назад к списку
            </Link>

            <div className={'blog-item-container__header'}>
                <p className={'blog-item-container__date'}>{date}</p>
                <h1>{blogItemData.title}</h1>
                <p>{blogItemData.description}</p>
            </div>

            <div className={'blog-item-container__content'}>
                <img src={blogItemData.img} alt={blogItemData.title} width={400} height={200}/>
                <p>{blogItemData.text}</p>
            </div>
        </div>
    );
}

export default BlogItem;